// 전광판 보드 목 데이터 //
// 백엔드 공개 API(api2/public/board/...) 응답 스펙과 1:1 동일한 형태를 유지한다 //
// 실 API 연결시 EventBoardPage 의 IS_USE_MOCK_DATA 상수만 false 로 변경하면 된다 //

const REGION_NAMES = {
  gwangju: '경기 광주',
  daegu: '대구',
  cheongju: '청주'
};

const IRON_RANKS = [
  { rank: 1, name: '크로스핏 강남 알파', profile: '', record: '20:30', recordType: 'Time', point: null, isSuccess: true, tieBreak: '02:45' },
  { rank: 2, name: 'THUNDER CREW', profile: '', record: '21:04', recordType: 'Time', point: null, isSuccess: true, tieBreak: '03:12' },
  { rank: 3, name: '바벨브라더스 서초점', profile: '', record: '21:47', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 4, name: 'IRONWORKS', profile: '', record: '22:15', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 5, name: '핏앤스트롱 크루', profile: '', record: '23:02', recordType: 'Time', point: null, isSuccess: true, tieBreak: null }
];

const UNION_RANKS = [
  { rank: 1, name: 'MIXED FORCE', profile: '', record: '5R 12Reps', recordType: null, point: 50, isSuccess: false, tieBreak: '01:58' },
  { rank: 2, name: '유니온 원팀', profile: '', record: '5R 8Reps', recordType: null, point: null, isSuccess: false, tieBreak: null },
  { rank: 3, name: 'ONE TEAM ONE DREAM', profile: '', record: '4R 20Reps', recordType: null, point: null, isSuccess: false, tieBreak: null },
  { rank: 4, name: '한강크로스핏 혼성팀', profile: '', record: '4R 15Reps', recordType: null, point: null, isSuccess: false, tieBreak: null },
  { rank: 5, name: 'RISE UP', profile: '', record: '4R 2Reps', recordType: null, point: null, isSuccess: false, tieBreak: null }
];

const FLARE_RANKS = [
  { rank: 1, name: 'FLARE QUEENS', profile: '', record: '18:22', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 2, name: '레이디스 크로스핏 판교', profile: '', record: '19:10', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 3, name: 'BLOSSOM', profile: '', record: '19:58', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 4, name: '파이어걸스', profile: '', record: '20:41', recordType: 'Time', point: null, isSuccess: true, tieBreak: null },
  { rank: 5, name: 'SISTERS OF STEEL', profile: '', record: '21:33', recordType: 'Time', point: null, isSuccess: true, tieBreak: null }
];

const BOARDS = [
  {
    wodId: 291,
    wodSlug: 'flash',
    wodTitle: 'FLASH',
    wodSubTitle: 'E1',
    viewIndex: 1,
    isOpen: true,
    leagues: [
      { leagueId: 405, leagueName: 'IRON LEAGUE', ranks: IRON_RANKS },
      { leagueId: 406, leagueName: 'FLARE LEAGUE', ranks: [] },
      { leagueId: 407, leagueName: 'UNION LEAGUE', ranks: UNION_RANKS }
    ]
  },
  {
    wodId: 292,
    wodSlug: 'titan',
    wodTitle: 'TITAN',
    wodSubTitle: 'E2',
    viewIndex: 2,
    isOpen: true,
    leagues: [
      { leagueId: 405, leagueName: 'IRON LEAGUE', ranks: IRON_RANKS },
      { leagueId: 406, leagueName: 'FLARE LEAGUE', ranks: FLARE_RANKS.slice(0, 3) },
      { leagueId: 407, leagueName: 'UNION LEAGUE', ranks: UNION_RANKS }
    ]
  },
  {
    wodId: 293,
    wodSlug: 'striker',
    wodTitle: 'STRIKER',
    wodSubTitle: 'E3',
    viewIndex: 3,
    isOpen: true,
    leagues: [
      { leagueId: 405, leagueName: 'IRON LEAGUE', ranks: IRON_RANKS.slice(0, 2) },
      { leagueId: 406, leagueName: 'FLARE LEAGUE', ranks: FLARE_RANKS },
      { leagueId: 407, leagueName: 'UNION LEAGUE', ranks: [] }
    ]
  }
];

// 지역 슬러그와 와드 슬러그로 목 데이터 추출 //
export function getBoardMockData(region, wodSlug) {
  const regionName = REGION_NAMES[region];

  if (regionName === undefined) return undefined;

  let boards = BOARDS;

  if (wodSlug !== undefined) {
    boards = BOARDS.filter((board) => board.wodSlug === wodSlug);

    if (boards.length === 0) return undefined;
  }

  return {
    organizerId: 66,
    tournamentTitle: '2026 BATTLE CREW LEAGUE',
    region: region,
    regionName: regionName,
    eventId: 244,
    boards: boards
  };
}
